export var QuotationsVersion;
(function (QuotationsVersion) {
    QuotationsVersion["Editorial"] = "editorial";
    QuotationsVersion["Personal"] = "personal";
})(QuotationsVersion || (QuotationsVersion = {}));
